import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon, UnseenIcon, SeenIcon, BotIcon} from "../svg/svgIcons";
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { Checkbox } from 'primereact/checkbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Avatar } from 'primereact/avatar';
import AuthContext from '../../components/AuthContext';
import { DateTime } from "luxon";
import { getTimezone } from '../../utils/moduleSettings';
import { ExecutionDeadlineFormatter } from "../checklists/ChecklistExecutionDeadline";
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import {
  cleanSorters,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  rowPassesChecklistHeaderFilters,
  refreshProgressiveFromStart,
  mergePagedChecklistStateListFiltersAndSorters,
  safeParse,
  applyChecklistDetailColumnLayout,
  restoreChecklistDetailUserMaskToTable,
  TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS,
} from '../../utils/tabulatorProgressiveLoading';
import { getEffectiveMask } from '../../utils/effectiveMask';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { buildTabulatorIdColumn } from '../../utils/tabulatorIdColumn';
import {
  TABULATOR_AUDIT_PROFILES,
  buildAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
} from '../../utils/tabulatorAuditColumns';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { getPusherChannel } from '../../utils/pusherChannel';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
const MAINTENANCE_CHECK_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'template.name': 'Common.Name',
  'defined_id': 'Common.ChecklistNumber',
  'is_unread': 'Common.Read',
  'name': 'Common.Description',
  'custom_department': 'Common.Department',
  'user_update_at': 'Common.CompletionDate',
  'execution_deadline': 'Common.CompletionDeadline',
  'status': 'Common.Status',
  'process_status': 'Common.ProcessStatus',
  'manager_name': 'Common.StatementDate',
  'manager_status': 'Common.StatementStatus',
  'checklist_status': 'Common.ChecklistStatus',
  'rowSelection': 'Common.Name',
  'template.machine.name': 'Common.Machine',
  'deadline': 'ChecklistRecordList.Column.StatementDeadline',
  'manager_response': 'MaintenanceCheckStateList.Column.Statement',
});



const MASK_PAGE = 'MaintenanceCheckStateList';

const CHECK_STATE_LIST_COLUMN_FIELD_ORDER = Object.freeze([
  'rowSelection',
  'editor',
  'id',
  'template.name',
  'template.machine.name',
  'defined_id',
  'is_unread',
  'name',
  'custom_department',
  'user_update_at',
  'execution_deadline',
  'status',
  'process_status',
  'manager_name',
  'deadline',
  'manager_response',
  'manager_status',
  'checklist_status',
  'created_at',
  'updated_at',
]);

const DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY = Object.freeze({
  rowSelection: true,
  editor: true,
  id: true,
  'template.name': true,
  'template.machine.name': true,
  defined_id: true,
  is_unread: true,
  name: true,
  custom_department: true,
  user_update_at: true,
  execution_deadline: true,
  status: true,
  process_status: true,
  manager_name: true,
  deadline: true,
  manager_response: true,
  manager_status: true,
  checklist_status: true,
  created_at: true,
  updated_at: true,
});

function mergeCheckStateListColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY, saved);
}

function applyCheckStateListDataColumnVisibility(table, visibility) {
  if (!table) return;
  for (const field of Object.keys(DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY)) {
    if (field === 'rowSelection' || field === 'editor') continue;
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceCheckStateList({preview=null}){

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const { t, locale } = useContext(LocaleContext);
  const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,getSlovakColorName,getUserInitials,getUserColor,formatID,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);
  const canSetStandardMask = user?.permissions?.includes('set standard mask');

  const pageSizePc = useMemo(() => {
    const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
    const n = parseInt(v, 10);
    return (Number.isFinite(n) && n > 0) ? n : 50;
  }, [state.module_settings]);
  const timezone = getTimezone(state?.module_settings || []);
  const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
  const dateTimeFmt = `${dateFmt} HH:mm`;

  const [stepBackIcon,setStepBackIcon] = useState(true);
  const [editIcon,setEditIcon] = useState(true);
  const [deleteIcon,setDeleteIcon] = useState(true);
  const [favoriteIcon,setFavoriteIcon] = useState(false);
  const [copyIcon,setCopyIcon] = useState(true);

  const [visibleSearch,setVisibleSearch] = useState(false);
  const [searchValue,setSearchValue] = useState('');

    const [editFormDepartment, setEditFormDepartment] = useState([]);

  const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY }));
  const [maskVisible, setMaskVisible] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState({});
  const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const needsRedrawRef = useRef(false);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);
    const isTableVisible = useCallback(() => {
        const table = getTable();
        if (!table) return false;
        const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
        return !!(el && el.offsetParent != null && el.clientHeight > 0);
    }, [getTable]);
    const scheduleRedraw = useCallback(() => {
        if (rafRedrawRef.current != null) return;
        rafRedrawRef.current = requestAnimationFrame(() => {
            const table = getTable();
            rafRedrawRef.current = null;
            if (!table) return;
            const ids = Array.from(pendingRowIdsRef.current);
            pendingRowIdsRef.current.clear();
            needsRedrawRef.current = false;
            const headerFilters = table.getHeaderFilters?.() ?? [];
            ids.forEach((id) => {
                const row = table.getRow?.(id);
                if (!row) return;
                const data = row.getData?.();
                if (!data) return;
                if (!rowPassesChecklistHeaderFilters(data, headerFilters)) {
                    row.delete?.();
                    return;
                }
                row.reformat?.();
            });
        });
    }, [getTable]);

    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    function matchAny(data, filterParams) {
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

    function searchTable(){
      const table = getTable();
      if (!table) return;
      table.setFilter(matchAny, { value: searchValue});
      if (searchValue === " ") {
        table.clearFilter();
      }
      setVisibleSearch(false);
    }

    const accept = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        const idsToDelete = rows_to_delete.map(r => r.id);

        const deletePromises = rows_to_delete.map((element) =>
            deleteRequest(`/api/checklist_records/${element.id}`)
        );

        Promise.allSettled(deletePromises).then((results) => {
            const successCount = results.filter(r => r.status === "fulfilled").length;
            const failCount = results.filter(r => r.status === "rejected").length;

            if (successCount > 0 && failCount === 0) {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), detail: t('Common.Toast.RecordsDeletedCount', { count: successCount }), life: 3000 });
            } else if (successCount > 0 && failCount > 0) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Toast.PartialDeletedSummary'), detail: t('Common.Toast.PartialDeletedCount', { ok: successCount, fail: failCount }), life: 3000 });
            } else {
                toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: t('Common.Toast.NoneDeletedDetail'), life: 3000 });
            }

            if (successCount > 0) {
                idsToDelete.forEach(id => {
                    const row = getTable()?.getRows?.().find(r => r.getData().id === id);
                    if (row) row.delete();
                });
            } else {
                refreshFromStart();
            }
        });
    };

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecords'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

const rowClick = (e, row) => {
    console.log(e, row);
};

const onSelectRow = (data) => {
  setEditIcon(true);
  setCopyIcon(true);
  setDeleteIcon(true);
  const table = getTable();
  if (!table?.getSelectedData) return;
  if (table.getSelectedData().length === 1) {
      if (user.permissions?.includes("edit maintenance")) setEditIcon(false);
      if (user.permissions?.includes("delete maintenance")) setDeleteIcon(false);
      if (user.permissions?.includes("add maintenance")) setCopyIcon(false);
      setEditFormDepartment(data);
  } else if (table.getSelectedData().length > 1) {
    if (user.permissions?.includes("delete maintenance")) setDeleteIcon(false);
  }
};

function onEditRow(checklist_record){
  const table = getTable();
  const navCtx = table?.getHeaderFilters ? { filters: table.getHeaderFilters(), sorters: cleanSorters(table.getSorters?.() || []) } : null;
  dispatch({type: 'create_new_tab', name: t('Common.ChecklistRecord'), translationKey: 'Common.ChecklistRecord', legacyLabel: t('Common.ChecklistRecord'),page:'ChecklistRecordAllDetail',props:{checklist_record: checklist_record, recordId: checklist_record?.id, type:'edit', navigationContext: navCtx, machinesOnly: true},mask:'chck006'});
};

function EditRowFormatter(props) {
  const rowData = props.cell.getRow().getData();
  return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
}

function removeDiacritics(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const extractDepartmentsFromRecipients = (recipients) => {
      const departmentMap = new Map();

      recipients.forEach((user) => {
          const dept = user?.employee?.department;
          if (dept && !departmentMap.has(dept.id)) {
            departmentMap.set(dept.id, {
                id: dept.id,
                name: dept.name,
                searchLabel: removeDiacritics(dept.name).toLowerCase(),
            });
          }
          else if(user?.employee?.department_id){
            let db_dept = state.departments.find(department => department.id == user?.employee?.department_id);
            departmentMap.set(db_dept.id, {
                id: db_dept.id,
                name: db_dept.name,
                searchLabel: removeDiacritics(db_dept.name).toLowerCase(),
            });
          }
      });

      return Array.from(departmentMap.values());
  };

function DepartmentFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return extractDepartmentsFromRecipients([rowData?.user]).map(departmnent => departmnent?.name).join(', ');
}

  function ManagerFormatter(props) {
    const rowData = props.cell.getRow().getData();
    if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return "";
    const isBotCase = rowData?.status === "OK" && (rowData?.checklist_status || "").toLowerCase() === 'uzavretý';
    const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;
    return (
      <div className="flex items-center justify-start w-full h-full">
        {isBotCase ? (
          <div className="mr-2">
            <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
          </div>
        ) : (
          (rowData?.manager || rowData?.template?.manager) && (
            <div className='mr-2'>
              <Avatar
                title={rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username}
                label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username)}
                shape="circle"
                style={{
                  backgroundColor: getUserColor(rowData?.manager?.username || rowData?.template?.manager?.username),
                  color: "#ffffff",
                  marginRight: "5px",
                }}
              />
            </div>
          )
        )}

        {timeToShow && (
          <div>
            {/* ak máš SQL string */}
            {DateTime.fromSQL(timeToShow).toFormat(dateTimeFmt)}
          </div>
        )}
      </div>
    );
  }

    function IDRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.id)return formatID("CHL-",3,rowData?.id);
        return t('Common.NotCreated');
    } 
    
    const processStatusOptions = [
      { label: t('Common.Created'), value: "Vytvorený" },
      { label: t('Common.InProgress'), value: "Rozpracovaný" },
      { label: t('Common.NotCreated'), value: "Nevytvorený" },
      { label: t('Common.InProgressOrNotCreated'), value: "Rozpracovaný,Nevytvorený" },
    ];

    function DeadlineFormatter(props) {
      const rowData = props.cell.getRow().getData();
      const baseDate = DateTime.fromISO(rowData.created_at);
      const deadline = baseDate.plus({ days: rowData.template.manager_due_days }).startOf("day");
      const now = DateTime.now().setZone(timezone);

      // Dátum vyjadrenia (použi reálne pole, ktoré u vás znamená "vyjadrené")
      // Dávam viac možností, aby to fungovalo aj keď je názov iný.
      const expressedAtIso = rowData?.manager_update_at || null;
      const expressedTmp = expressedAtIso ? DateTime.fromISO(expressedAtIso) : null;
      const expressedAt = expressedTmp?.isValid ? expressedTmp : null;

      // ak je vyjadrené po deadline => červené
      const isLateExpression = !!(expressedAt && expressedAt > deadline);

      // ak ešte nie je vyjadrené a deadline prešiel => červené
      const isExpiredAndNotExpressed = !expressedAt && now > deadline;

      const isRed = (isLateExpression || isExpiredAndNotExpressed) && rowData?.status !== "OK";

      const managerName =
        rowData?.manager?.employee?.name ||
        rowData?.manager?.username ||
        rowData?.template?.manager?.employee?.name ||
        rowData?.template?.manager?.username ||
        "";

      const managerUsername =
        rowData?.manager?.username ||
        rowData?.template?.manager?.username ||
        "";

      return (
        <div className="flex items-center justify-start w-full h-full">
          {(rowData?.manager || rowData?.template?.manager) && (
            <div className='mr-2'>
              <Avatar
                title={managerName}
                label={getUserInitials(managerName)}
                shape="circle"
                style={{
                  backgroundColor: getUserColor(managerUsername),
                  color: "#ffffff",
                  marginRight: "5px",
                }}
              />
            </div>
          )}
          {/* Deadline vyjadrenia nechávame vždy zobrazovať, aj po vyjadrení */}
          <div
              className={`${
                isRed ? "text-red-600 font-semibold" : ""
              }`}
            >
              {deadline.toFormat(dateFmt)}
            </div>
        </div>
      );
    }

    function UserUpdateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        // RAW API process_status tokens (Nevytvorený / Rozpracovaný) — do not localize
        if (rowData?.process_status === 'Nevytvorený' || rowData?.process_status === 'Rozpracovaný') return;
        return <div className='flex items-center justify-start w-full h-full'>
            {rowData?.user && <div><Avatar title={rowData?.user?.employee?.name || rowData?.user?.username} label={getUserInitials(rowData?.user?.employee?.name || rowData?.user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff',marginRight: '5px'}} /></div>}
            <div>{DateTime.fromSQL(rowData.user_update_at).toFormat(dateTimeFmt)}</div>
        </div>;
    }

    const markAsViewed = async (recordId, value) => {
      const formData = new FormData();
      formData.append("record_id", recordId);
      formData.append("user_id", user.id);
      const url = !value
        ? `/api/checklist_records/${recordId}/mark-as-viewed`
        : `/api/checklist_records/${recordId}/mark-as-not-viewed`;
      try {
        await postRequest(url, formData, true);
        const row = getTable()?.getRows?.().find(r => r.getData().id === recordId);
        if (row) row.update({ is_unread: value });
      } catch (err) {}
    };

    
  function MailIconTemplate(props) {
    const rowData = props.cell.getRow().getData();
    if (rowData?.manager_response || rowData?.comments?.length > 0) {
      const isUnread = rowData?.is_unread;

      return (
        <div className="flex items-center gap-2">
          {isUnread ? (
            <button type="button" title={t('Common.MarkAsRead')} onClick={() => markAsViewed(rowData.id, false)} className="hover:opacity-75">
              <UnseenIcon />
            </button>
          ) : (
            <button type="button" title={t('Common.MarkAsUnread')} onClick={() => markAsViewed(rowData.id, true)} className="hover:opacity-75">
              <SeenIcon />
            </button>
          )}
        </div>
      );
    }
    return "";
  }

    const remoteHeaderFilter = useCallback(() => true, []);

    const checklistAuditTailColumns = useMemo(() => {
        return buildAuditTabulatorColumns({
            profile: TABULATOR_AUDIT_PROFILES.checklistCreatorLastTouched,
            includeId: false,
            dateFormat: dateFmt,
            dateTimeFormat: dateTimeFmt,
            getUserColor,
            getUserInitials,
            textHeaderFilter: remoteHeaderFilter,
            remotePassthrough: true,
        });
    }, [dateFmt, dateTimeFmt, getUserColor, getUserInitials, remoteHeaderFilter]);

    const columns = useMemo(
        () => [
            {
                formatter: 'rowSelection',
                titleFormatter: 'rowSelection',
                field: 'rowSelection',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                frozen: true,
                print: false,
                download: false,
            },
            {
                title: '',
                field: 'editor',
                hozAlign: 'center',
                width: 44,
                minWidth: 44,
                headerSort: false,
                formatter: reactFormatter(<EditRowFormatter />),
                resizable: false,
                frozen: true,
                print: false,
                download: false,
            },
            buildTabulatorIdColumn({
              frozen: true,
              headerFilterFunc: remoteHeaderFilter,
            }),
            {
                title: t('Common.Name'),
                field: 'template.name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
            },
            {
                title: t('Common.Machine'),
                field: 'template.machine.name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
            },
            {
                title: t('Common.ChecklistNumber'),
                field: 'defined_id',
                formatter: reactFormatter(<IDRowFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 100,
                widthGrow: 1,
            },
            {
                title: t('Common.Read'),
                field: 'is_unread',
                minWidth: 100,
                resizable: false,
                formatter: reactFormatter(<MailIconTemplate />),
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: t('Common.Unread'), value: 'true' },
                        { label: t('Common.Read'), value: 'false' },
                    ],
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Description'),
                field: 'name',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 190,
            },
            {
                title: t('Common.Department'),
                field: 'custom_department',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 190,
                formatter: reactFormatter(<DepartmentFormatter />),
            },
            {
                title: t('Common.CompletionDate'),
                field: 'user_update_at',
                minWidth: 230,
                formatter: reactFormatter(<UserUpdateFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.CompletionDeadline'),
                field: 'execution_deadline',
                minWidth: 230,
                formatter: reactFormatter(<ExecutionDeadlineFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.Status'),
                field: 'status',
                minWidth: 100,
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: [
                        { label: 'OK', value: 'OK' },
                        { label: 'NOK', value: 'NOK' },
                    ],
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.ProcessStatus'),
                field: 'process_status',
                minWidth: 160,
                headerFilter: primeMultiSelectHeaderFilter,
                headerFilterParams: {
                    placeholder: t('Common.All'),
                    valueType: 'string',
                    options: processStatusOptions.map((o) => ({ label: o.label, value: o.value })),
                },
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('Common.StatementDate'),
                field: 'manager_name',
                minWidth: 200,
                formatter: reactFormatter(<ManagerFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('ChecklistRecordList.Column.StatementDeadline'),
                field: 'deadline',
                minWidth: 210,
                formatter: reactFormatter(<DeadlineFormatter />),
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
            },
            {
                title: t('MaintenanceCheckStateList.Column.Statement'),
                field: 'manager_response',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            {
                title: t('Common.StatementStatus'),
                field: 'manager_status',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            {
                title: t('Common.ChecklistStatus'),
                field: 'checklist_status',
                headerFilter: inputOnEnterHeaderFilter,
                headerFilterLiveFilter: false,
                headerFilterFunc: remoteHeaderFilter,
                minWidth: 200,
                widthGrow: 1,
            },
            ...checklistAuditTailColumns,
        ],
        [checklistAuditTailColumns, remoteHeaderFilter, processStatusOptions]
    );

  function editChecklistRecord(){
    const rec = getTable()?.getSelectedData?.()?.[0];
    if (!rec) return;
    const table = getTable();
    const navCtx = table?.getHeaderFilters ? { filters: table.getHeaderFilters(), sorters: cleanSorters(table.getSorters?.() || []) } : null;
    dispatch({type: 'create_new_tab', name: t('Common.ChecklistRecord'), translationKey: 'Common.ChecklistRecord', legacyLabel: t('Common.ChecklistRecord'),page:'ChecklistRecordAllDetail',props:{checklist_record: rec, recordId: rec?.id, type:'edit', navigationContext: navCtx, machinesOnly: true},mask:'chck006'});
  }

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());

 const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const closeMenu = useCallback(() => {
    setTimeout(() => {
      OverflowMenuProvider.setVisible?.(null);
      setExpandedKeys({});
    }, 0);
  }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: MAINTENANCE_CHECK_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


  const hasApplicableStandardMask = useMemo(
    () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeCheckStateListColumnVisibilityFromSaved),
    [state.standard_mask_filters]
  );

  const openMaskDialog = useCallback(
    createOpenMaskDialog({
      columnsVisible,
      setColumnsVisible,
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      mergeVisibilityFromSaved: mergeCheckStateListColumnVisibilityFromSaved,
      setMaskVisible,
      closeMenu,
    }),
    [columnsVisible, closeMenu]
  );

  const saveUserMaskColumns = useCallback(
    createSaveUserMaskColumns({
      maskPage: MASK_PAGE,
      getTable,
      setUserMaskFilter,
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      columnsVisible,
      setColumnsVisible,
      setMaskVisible,
      toast,
    }),
    [columnsVisible, getTable, setUserMaskFilter, toast]
  );

  const confirmSaveStandardMask = useCallback(
    createConfirmSaveStandardMask({
      maskPage: MASK_PAGE,
      getTable,
      setStandardMaskFilter,
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      toast,
    }),
    [getTable, setStandardMaskFilter, toast]
  );

  const confirmApplyStandardLayoutToUserMask = useCallback(
    createConfirmApplyStandardLayoutToUserMask({
      maskPage: MASK_PAGE,
      state,
      setUserMaskFilter,
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      mergeVisibilityFromSaved: mergeCheckStateListColumnVisibilityFromSaved,
      toast,
      closeMenu,
      onAppliedToTable: ({ colsForSave, attributes }) => {
        const table = getTable();
        if (!table) return;
        isRestoringRef.current = true;
        applyChecklistDetailColumnLayout(table, attributes, CHECK_STATE_LIST_COLUMN_FIELD_ORDER, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
        applyCheckStateListDataColumnVisibility(table, colsForSave);
        setColumnsVisible(colsForSave);
        setTimeout(() => {
          isRestoringRef.current = false;
          captureHScroll();
          refreshFromStart();
        }, 0);
      },
    }),
    [state, closeMenu, getTable, setUserMaskFilter, toast, captureHScroll, refreshFromStart]
  );

  const setMask = useCallback(
    createMaskSetFieldHandler({
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      columnsVisible,
      setColumnsVisible,
      getTable,
      applyVisibilityToTable: applyCheckStateListDataColumnVisibility,
      toast,
    }),
    [columnsVisible, getTable, toast]
  );

  const maskSelectAll = useCallback(
    createMaskSelectAllHandler({
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      setColumnsVisible,
      getTable,
      applyVisibilityToTable: applyCheckStateListDataColumnVisibility,
    }),
    [getTable]
  );

  const maskDeselectAll = useCallback(
    createMaskDeselectAllHandler({
      defaultColumnVisibility: DEFAULT_CHECK_STATE_LIST_COLUMN_VISIBILITY,
      setColumnsVisible,
      getTable,
      applyVisibilityToTable: applyCheckStateListDataColumnVisibility,
    }),
    [getTable]
  );

  const handleClickOutside = (event) => {
    if (event.target.closest('[data-overflow-trigger]')) return;
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
        OverflowMenuProvider.setVisible?.(null);
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => document.removeEventListener('click', handleClickOutside, true);
  }, []);

  const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
    const extra = { machines_only: 1, ...extractSafePaginationParams(paramsFromTabulator) };
    if (extra.size == null) extra.size = pageSizePc;
    if (preview === "OK") extra.filter_status = "OK";
    else if (preview === "NOK") extra.filter_status = "NOK";
    else if (['nevytvorene', 'rozpracovane', 'nok_vytvorene', 'chyba_vyjadrenie'].includes(preview)) extra.preview = preview;

    mergePagedChecklistStateListFiltersAndSorters(extra, {
      table: getTable(),
      tableBuiltForParams: tableBuiltRef.current,
      userMaskFilters: state.user_mask_filters,
      maskPage: MASK_PAGE,
      preview,
    });
    return extra;
  }, [preview, pageSizePc, state.user_mask_filters, getTable]);

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: buildMaintenanceMaskAkcieSubItems({
        maskPage: MASK_PAGE,
        getTable,
        setUserMaskFilter,
        cleanSorters,
        captureHScroll,
        refreshFromStart,
        closeMenu,
        openMaskDialog,
        openChosenNotificationPreferences,
        hasApplicableStandardMask,
        confirmApplyStandardLayoutToUserMask,
        itemRenderer,
      }),
    }
  ];

  // ResizeObserver: keď sa záložka znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
  const lastContainerHeightRef = useRef(0);
  useEffect(() => {
    const container = elementRef.current;
    if (!container) return;
    const ro = new ResizeObserver(() => {
      const h = container.clientHeight;
      if (h > 0) {
        const wasHidden = lastContainerHeightRef.current <= 0;
        lastContainerHeightRef.current = h;
        if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
        else if (needsRedrawRef.current && isTableVisible()) scheduleRedraw();
      } else {
        lastContainerHeightRef.current = 0;
      }
    });
    ro.observe(container);
    return () => ro.disconnect();
  }, [isTableVisible, scheduleRedraw, getTable]);

  useEffect(() => {
    const channel = getPusherChannel();
    if (!channel) return;
    const getId = (data) => data?.id ?? data?.record?.id ?? null;
    const DEDUPE_MS = 800;
    const lastHandled = { key: '', at: 0 };
    const shouldSkip = (eventType, id) => {
      if (id == null) return true;
      const key = `${eventType}-${id}`;
      const now = Date.now();
      if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
      lastHandled.key = key;
      lastHandled.at = now;
      return false;
    };

    const onUpdated = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('updated', id)) return;
      if (!getTable()?.getRow && !getTable()?.addData) return;
      getRequest(`/api/checklist_records/${id}`)
        .then((res) => {
          const record = res?.data ?? res;
          if (!record?.id) return;
          const table = getTable();
          if (record?.validity === 0) {
            const row = table?.getRow?.(record.id) ?? table?.getRows?.().find((r) => r.getData().id === record.id);
            if (row) row.delete();
            return;
          }
          const row = table?.getRow?.(record.id) ?? table?.getRows?.().find((r) => r.getData().id === record.id);
          if (row) {
            row.update(record);
          } else {
            table?.addData?.([record]);
          }
          pendingRowIdsRef.current.add(record.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        })
        .catch(() => {});
    };
    const onCreated = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('created', id)) return;
      if (!getTable()?.addData) return;
      getRequest(`/api/checklist_records/${id}`)
        .then((res) => {
          const record = res?.data ?? res;
          if (!record?.id || record?.validity === 0) return;
          const table = getTable();
          table?.addData?.([record], true);
          pendingRowIdsRef.current.add(record.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        })
        .catch(() => {});
    };
    const onDeleted = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('deleted', id)) return;
      const table = getTable();
      const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
      if (row) row.delete();
    };
    channel.bind('checklist_record.created', onCreated);
    channel.bind('checklist_record.updated', onUpdated);
    channel.bind('checklist_record.deleted', onDeleted);
    return () => {
      channel.unbind('checklist_record.created', onCreated);
      channel.unbind('checklist_record.updated', onUpdated);
      channel.unbind('checklist_record.deleted', onDeleted);
    };
  }, [getTable, isTableVisible, scheduleRedraw]);

    return(
        <>

    <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
        {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="add"><button onClick={() => addNewDepartment()}><AddIcon/></button></div>*/}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editChecklistRecord()}><EditIcon/></button></div>
        {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyDepartment()}><CopyIcon/></button></div>*/}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="print"><button type="button" onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="search"><button onClick={() => setVisibleSearch(true)}><SearchIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="export"><button type="button" onClick={() => getTable()?.download?.("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('MaintenanceCheckStateList.Text.Uplny_zoznam_checklistov'),"MaintenanceCheckStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="price"><button type="button" onClick={() => setFastView("MaintenanceCheckStateList", columnsVisible, columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        {canSetStandardMask ? (
          <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
            <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
              <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
            </button>
          </div>
        ) : null}
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
          <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
        </div>
        </IntersectionObserverWrapper>
      </div>
<div className="flex flex-col overflow-hidden min-h-[calc(100vh-177px)]">
  <div className="">
    <div className="inline-block w-full py-2">
    <div ref={elementRef}>
      <ReactTabulator
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          const table = getTable();
          if (!table) return;
          isRestoringRef.current = true;
          if (preview == null) {
            const effective = getEffectiveMask(MASK_PAGE, state);
            if (effective?.type === 'user' && effective.userMask) {
              restoreChecklistDetailUserMaskToTable(table, effective.userMask, {
                canonicalFieldOrder: CHECK_STATE_LIST_COLUMN_FIELD_ORDER,
                forceFrozenId: true,
                setColumnsVisible,
                clearHeaderFiltersWhenEmpty: true,
                applyColumnVisibilityFn: (tbl, jc, setVis) => {
                  const merged = mergeCheckStateListColumnVisibilityFromSaved(jc);
                  setVis(merged);
                  applyCheckStateListDataColumnVisibility(tbl, merged);
                },
              });
            } else if (effective?.type === 'standard' && effective.standardMask) {
              const m = effective.standardMask;
              const jsonColumns = safeParse(m.columns, {});
              applyChecklistDetailColumnLayout(table, safeParse(m.attributes, []), CHECK_STATE_LIST_COLUMN_FIELD_ORDER, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
              if (jsonColumns && typeof jsonColumns === 'object') {
                const merged = mergeCheckStateListColumnVisibilityFromSaved(jsonColumns);
                setColumnsVisible(merged);
                applyCheckStateListDataColumnVisibility(table, merged);
              }
            } else {
              applyCheckStateListDataColumnVisibility(table, columnsVisible);
            }
          } else {
            applyCheckStateListDataColumnVisibility(table, columnsVisible);
          }
          setTimeout(() => {
            isRestoringRef.current = false;
          }, 0);
          tableBuiltRef.current = true;
          refreshFromStart();
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => {
          if (!isRestoringRef.current) {
            captureHScroll();
            refreshFromStart();
          }
        },
        sortChanged: () => {
          if (!isRestoringRef.current) {
            captureHScroll();
            refreshFromStart();
          }
        },
        renderComplete: () => { restoreHScroll(); },
      }}
      options={{
        height: "calc(100vh - 193px)",
        layout: "fitColumns",
        rowHeight: 42,
        movableColumns: true,
        printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceCheckStateList'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
        printRowRange: "active",
        autoResize: true,
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        placeholder: t('Common.NoData'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 0,
        progressiveLoadDelay: 200,
        paginationSize: pageSizePc,
        progressiveRender: true,
        progressiveRenderSize: 30,
        filterMode: "remote",
        sortMode: "remote",
        ajaxURL: "/api/checklist_all_records/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        headerSortTristate: true,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          getTable()?.alert?.(t('Common.LoadingData'));
          return true;
        },
        ajaxResponse: (url, params, response) => { getTable()?.clearAlert?.(); return response; },
        ajaxError: () => { getTable()?.clearAlert?.(); },
      }}/> 
    </div> 
      </div>
    </div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
                  <div className="flex flex-col">
                  <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
                  <div className="flex flex-wrap gap-2 mb-2">
                    <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
                    <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
                  </div>
                  {columns.map((item) => {
                    if (!item.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                              return <div
                                  key={item.field}
                                  className="flex flex-row border border-black rounded-md p-2 m-1"
                              >
                                   <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mcsl-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`mcsl-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title || item.field}</label>
                              </div>
                          })}
                          <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
                  </div>
              </Dialog>
</div>
 </>
    )

}